import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, TRANSLATION_KEY, {
  MODULE_HOME: 'Home',
  MODULE_HANA: 'Crehana AI',
  MODULE_RECOGNITION: 'Recognition',
  MODULE_PERFORMANCE: 'Performance',
  MODULE_CLIMATE: 'Climate',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Company',
  MODULE_ANALYTICS: 'Analytics',
  MODULE_ADMIN: 'Admin',
  MODULE_STATISTICS: 'Statistics',
  MODULE_REPORTS: 'Reports',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitor your processes and generate reports.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: "Analyze your company's data with Artificial Intelligence.",
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTS',
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Manage the badges awarded by the collaborators.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Evaluate performance through goals and competencies.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Measure the culture and satisfaction of your team.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: "Manage learning strategies and enhance your team's skills.",
  MODULE_COMPANY_USERS: 'Users',
  MODULE_COMPANY_EXTRA_FIELDS: 'Personalized attributes',
  MODULE_COMPANY_DEPARTMENTS: 'Departments',
  MODULE_COMPANY_JOBS: 'Jobs',
  MODULE_COMPANY_ORGCHART: 'Organization chart',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Manage your users and company settings.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Create users and manage the organizational structure.',
  MODULE_ACCOUNT: 'Account',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Manage account data and check license consumption.',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'History of actions carried out in the account.',
  MODULE_APPEREANCE: 'Appearance',
  MODULE_APPEREANCE_TOOLTIP_DESCRIPTION: 'Customize the panel with the organizational identity.',
  MODULE_COMMUNICATION: 'Communication',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Customize notifications for your users.',
  MODULE_AUTOMATIZATIONS: 'Automations',
  MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION: 'Create automation rules to streamline tasks.',
  // learning links
  LEARNING_LINK_CONTENT: 'Content',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Manage courses, learning paths, and other resources.',
  LEARNING_LINK_COURSES: 'Courses',
  LEARNING_LINK_PATHS: 'Learning Paths',
  LEARNING_LINK_PROJECTS: 'Projects',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill-XP evolution',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Measure the skills of each person.',
  LEARNING_LINK_GAMIFICATION: 'Gamification',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Create, manage, and reward learning achievements.',
  LEARNING_LINK_PROGRESS: 'Progress',
  LEARNING_LINK_REWARDS: 'Rewards',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitor your processes and generate reports.',
  LEARNING_LINK_SHOP: 'Shop',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Customize your virtual content store.',
  LEARNING_LINK_INTEGRATIONS: 'Integrations',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Connect the platform with other systems.',
  // submodules
  SUBMODULE_RESULTS: 'Results',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Check the results of the processes you participate in.',
  SUBMODULE_MY_TEAM: 'My Team',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitor the results of your team.',
  SUBMODULE_ADMIN_RESULTS: 'Results',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitor the ranking of medals obtained by your collaborators.',
  SUBMODULE_MEDALS_REQUETS: 'Medal Requests',
  SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION: 'Approve or reject the medals sent by the collaborators.',
  SUBMODULE_REWARDS: 'Rewards',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Manage and deliver redeemed rewards.',
  SUBMODULE_CONFIGURATION: 'Configuration',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Create medals, define rules and messages.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Results',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Measure performance and team commitment.',
  SUBMODULE_COMPETENCES: 'Competencies',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Create and assign competency assessments.',
  SUBMODULE_GOALS: 'Goals',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Plan and set your work commitments.',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualize the progress of the business strategy and recognize the effort to achieve the objectives.',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Measure the feedback processes in your company.',
  SUBMODULE_PID: 'Individual Development Plan',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Create processes to close gaps and promote growth.',
  SUBMODULE_SUCCESSION_PLAN: 'Succession Plan',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Create action plans for future vacancies.',
  SUBMODULE_LINK_GOALS: 'Goals',
  SUBMODULE_LINK_ALIGNMENT: 'Alignment',
  SUBMODULE_LINK_CONFIGURATION: 'Configuration',
  SUBMODULE_CLIMATE_EVALUATION: 'Climate Evaluations',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Access the questionnaire to measure the organizational climate.',
  SUBMODULE_SHORT_SURVEY: 'Short Surveys',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Collect information quickly and easily.',
  SUBMODULE_OTHER_EVALUATIONS: 'Other Evaluations',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Additional evaluations such as psychosocial risks.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medals',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Messages',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Rules and Permissions',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Create matrix crossing variables to visualize data.'
});